(function(){
'use strict';

var SOMMIER={
  '140×190 cm':{id:'57608734605660',price:120},
  '160×200 cm':{id:'57608755708252',price:150},
  '180×200 cm':{id:'57608755741020',price:200}
};
var MATELAS=[
  {label:'Nuage — 20 cm Mousse',sizes:{'140×190 cm':{id:'57465192317276',price:199},'160×200 cm':{id:'57465192350044',price:249},'180×200 cm':{id:'57465192382812',price:309}}},
  {label:'Riviera — 25 cm Mousse HR',sizes:{'140×190 cm':{id:'57465192448348',price:429},'160×200 cm':{id:'57465192481116',price:489},'180×200 cm':{id:'57465192513884',price:549}}},
  {label:'Rixos Prestige — 30 cm Mousse HR',sizes:{'140×190 cm':{id:'57465192579420',price:529},'160×200 cm':{id:'57465192612188',price:579},'180×200 cm':{id:'57465192644956',price:679}}},
  {label:'Velours — 26 cm Ressorts',sizes:{'140×190 cm':{id:'57465192677724',price:449},'160×200 cm':{id:'57465192710492',price:499},'180×200 cm':{id:'57465192743260',price:549}}},
  {label:'Ivoire — 32 cm Ressorts Luxe',sizes:{'140×190 cm':{id:'57465192841564',price:709},'160×200 cm':{id:'57465192874332',price:809},'180×200 cm':{id:'57465192907100',price:909}}},
  {label:'Cendré — 32 cm Ressorts Luxe',sizes:{'140×190 cm':{id:'57465192939868',price:709},'160×200 cm':{id:'57465192972636',price:809},'180×200 cm':{id:'57465193005404',price:909}}},
  {label:'Milano — 31 cm Ressorts',sizes:{'140×190 cm':{id:'57465193070940',price:549},'160×200 cm':{id:'57465193103708',price:599},'180×200 cm':{id:'57465193136476',price:699}}},
  {label:'Signature — 36 cm Ressorts Luxe',sizes:{'160×200 cm':{id:'57465193365852',price:1039},'180×200 cm':{id:'57465193398620',price:1199}}}
];

var cfg=window.VH_PRODUCT_EXTRAS||{};
var isCadre=cfg.isCadre||false;
var isCoffre=cfg.isCoffre||false;
var variantSizes=cfg.variantSizes||{};
var productTitle=cfg.productTitle||'';
var currentSize=null;
var lastVariantId=null;
var proxyInstalled=false;

function installProxy(){
  if(proxyInstalled)return;
  proxyInstalled=true;
  var orig=window.fetch;
  window.fetch=function(url,opts){
    var u=typeof url==='string'?url:(url&&url.url)||'';
    if(u.indexOf('/cart/add')!==-1){
      var extras=getExtras();
      if(extras.length>0){
        var ctx=this;
        return orig.call(ctx,url,opts).then(function(res){
          if(!res.ok)return res;
          return res.json().then(function(data){
            return orig.call(window,'/cart/add.js',{
              method:'POST',
              headers:{'Content-Type':'application/json','Accept':'application/json'},
              body:JSON.stringify({items:extras})
            }).then(function(){
              if(data.sections&&Object.keys(data.sections).length){
                var keys=Object.keys(data.sections);
                return orig.call(window,'/?sections='+encodeURIComponent(keys.join(',')))
                  .then(function(r){return r.json();})
                  .then(function(fresh){
                    data.sections=fresh;
                    return new Response(JSON.stringify(data),{status:200,headers:new Headers({'Content-Type':'application/json'})});
                  }).catch(function(){
                    return new Response(JSON.stringify(data),{status:200,headers:new Headers({'Content-Type':'application/json'})});
                  });
              }
              return new Response(JSON.stringify(data),{status:200,headers:new Headers({'Content-Type':'application/json'})});
            }).catch(function(){
              return new Response(JSON.stringify(data),{status:200,headers:new Headers({'Content-Type':'application/json'})});
            });
          });
        });
      }
    }
    return orig.call(this,url,opts);
  };
}

function getExtras(){
  var items=[];
  if(!currentSize)return items;
  var assocLabel=productTitle?productTitle+' — '+currentSize:currentSize;

  var sommierSel=document.getElementById('vh-sommier-select');
  if(sommierSel&&sommierSel.value==='oui'){
    var sv=SOMMIER[currentSize];
    if(sv){
      items.push({id:sv.id,quantity:1,properties:{'Associé à':assocLabel}});
    }
  }

  var matSel=document.getElementById('vh-matelas-select');
  if(matSel&&matSel.value&&matSel.value!==''){
    var matLabel=matSel.value;
    for(var i=0;i<MATELAS.length;i++){
      if(MATELAS[i].label===matLabel){
        var mv=MATELAS[i].sizes[currentSize];
        if(mv){
          items.push({id:mv.id,quantity:1,properties:{'Associé à':assocLabel}});
        }
        break;
      }
    }
  }
  return items;
}

function updSommier(){
  var sel=document.getElementById('vh-sommier-select');
  var info=document.getElementById('vh-sommier-info');
  if(!sel||!info)return;
  if(sel.value==='oui'&&currentSize&&SOMMIER[currentSize]){
    info.textContent='+ '+SOMMIER[currentSize].price+' €';
    info.style.display='inline';
  }else{
    info.textContent='';
    info.style.display='none';
  }
}

function updMatelas(){
  var sel=document.getElementById('vh-matelas-select');
  var info=document.getElementById('vh-matelas-info');
  if(!sel||!info)return;
  var label=sel.value;
  if(label&&currentSize){
    for(var i=0;i<MATELAS.length;i++){
      if(MATELAS[i].label===label){
        var mv=MATELAS[i].sizes[currentSize];
        if(mv){
          info.textContent='+ '+mv.price+' €';
          info.style.display='inline';
          return;
        }
      }
    }
  }
  info.textContent='';
  info.style.display='none';
}

function upd(variantId){
  var raw=variantSizes[variantId]||variantSizes[String(variantId)]||null;
  var size=raw?raw.replace(/\s*[xX\u00D7]\s*/g,'\u00D7'):raw;
  if(size&&!/cm/i.test(size))size=size+' cm';
  currentSize=size;
  updSommier();
  updMatelas();
  var matSel=document.getElementById('vh-matelas-select');
  if(matSel){
    var opts=matSel.options;
    for(var i=1;i<opts.length;i++){
      opts[i].disabled=false;
      opts[i].style.color='';
    }
  }
}

function poll(){
  var sel=document.querySelector('[name="id"]');
  if(sel){
    var v=sel.value;
    if(v!==lastVariantId){lastVariantId=v;upd(v);}
  }
}

function buildSommier(container){
  var div=document.createElement('div');
  div.className='vh-extra-row';
  div.innerHTML='<label class="vh-extra-label">Sommier<\/label>'
    +'<select id="vh-sommier-select" class="vh-extra-select">'
    +'<option value="">Non, sans sommier<\/option>'
    +'<option value="oui">Oui, avec sommier<\/option>'
    +'<\/select>'
    +' <span id="vh-sommier-info" class="vh-extra-price" style="display:none"><\/span>';
  container.appendChild(div);
  document.getElementById('vh-sommier-select').addEventListener('change',updSommier);
}

function buildMatelas(container){
  var div=document.createElement('div');
  div.className='vh-extra-row';
  var opts='<option value="">Non, sans matelas<\/option>';
  for(var i=0;i<MATELAS.length;i++){
    opts+='<option value="'+MATELAS[i].label+'">'+MATELAS[i].label+'<\/option>';
  }
  div.innerHTML='<label class="vh-extra-label">Matelas<\/label>'
    +'<select id="vh-matelas-select" class="vh-extra-select">'+opts+'<\/select>'
    +' <span id="vh-matelas-info" class="vh-extra-price" style="display:none"><\/span>';
  container.appendChild(div);
  document.getElementById('vh-matelas-select').addEventListener('change',updMatelas);
}

function build(){
  var container=document.getElementById('vh-extras-container');
  if(!container)return;
  container.innerHTML='';
  if(isCadre){buildSommier(container);buildMatelas(container);}
  else if(isCoffre){buildMatelas(container);}
  installProxy();
  setInterval(poll,250);
  poll();
}

function init(){
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',build);
  }else{
    build();
  }
}

init();
})();